import { useEffect, useState } from 'react';
import { api } from './api';

const KEY = 'guestWishlist';
const EVENT = 'wishlist-changed';
const hasToken = () => !!localStorage.getItem('token');

const readLocal = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const writeLocal = (ids) => { localStorage.setItem(KEY, JSON.stringify(ids)); window.dispatchEvent(new Event(EVENT)); };

let serverIds = null;

const setServer = (ids) => { serverIds = ids; window.dispatchEvent(new Event(EVENT)); };

export const wishlistStore = {
  ids: () => (hasToken() ? (serverIds || []) : readLocal()),
  has: (id) => wishlistStore.ids().includes(String(id)),
  load: async () => {
    if (!hasToken()) { window.dispatchEvent(new Event(EVENT)); return readLocal(); }
    const { data } = await api.get('/wishlist');
    setServer(data.product_ids);
    return data;
  },
  toggle: async (id) => {
    const pid = String(id);
    if (!hasToken()) {
      const ids = readLocal();
      writeLocal(ids.includes(pid) ? ids.filter(x => x !== pid) : [pid, ...ids]);
      return !ids.includes(pid);
    }
    const adding = !(serverIds || []).includes(pid);
    const { data } = adding ? await api.post(`/wishlist/${pid}`) : await api.delete(`/wishlist/${pid}`);
    setServer(data.product_ids);
    return adding;
  },
  fetchProducts: async () => {
    if (hasToken()) {
      const { data } = await api.get('/wishlist');
      setServer(data.product_ids);
      return data.products;
    }
    const ids = readLocal();
    if (!ids.length) return [];
    const { data } = await api.get('/products', { params: { ids: ids.join(',') } });
    return data;
  },
  mergeGuest: async () => {
    const ids = readLocal();
    if (!hasToken()) return;
    const { data } = ids.length ? await api.post('/wishlist/merge', { product_ids: ids }) : await api.get('/wishlist');
    localStorage.removeItem(KEY);
    setServer(data.product_ids);
  },
  reset: () => { serverIds = null; window.dispatchEvent(new Event(EVENT)); },
};

export const useWishlistIds = () => {
  const [ids, setIds] = useState(wishlistStore.ids);
  useEffect(() => {
    const sync = () => setIds([...wishlistStore.ids()]);
    window.addEventListener(EVENT, sync);
    if (hasToken() && serverIds === null) wishlistStore.load().catch(() => {});
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return ids;
};
